import classNames from 'classnames'

import {
  AllianceCivilisationLogo,
  PurgamenCivilisationLogo,
  LuminayanCivilisationLogo,
  RazatechCivilisationLogo,
  AxolotlCivilisationLogo,
  GalaktikaCivilisationLogo,
} from '../../assets/img'

export const CivilisationTitle = ({ civilisation, className, vertical }) => {
  return (
    <div
      className={classNames(
        vertical &&
          'lg:flex-col lg:px-3 lg:border-r lg:border-gold lg:h-full lg:justify-center lg:absolute',
        ['flex items-center gap-3 pb-3'],
        className,
      )}
    >
      <img
        className="w-14 md:w-14 lg:w-16"
        alt={`${civilisation} civilisation logo`}
        src={
          civilisation === 'Alliance'
            ? AllianceCivilisationLogo
            : civilisation === 'Purgamen'
            ? PurgamenCivilisationLogo
            : civilisation === 'Luminayan'
            ? LuminayanCivilisationLogo
            : civilisation === 'Razatech'
            ? RazatechCivilisationLogo
            : civilisation === 'Axolotl'
            ? AxolotlCivilisationLogo
            : civilisation === 'Galaktika'
            ? GalaktikaCivilisationLogo
            : ''
        }
      ></img>
      <h2
        className={classNames(vertical && 'text-vertical', [
          'text-gold uppercase',
        ])}
      >
        {civilisation}
      </h2>
    </div>
  )
}
